import { useMediaQuery } from 'react-responsive';
import MobileLogin from './MobileLogin';
import Login from './Login';

const LoginRouter = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 }); // adjust breakpoint if needed

  return isMobile ? <MobileLogin /> : <Login />;
};

export default LoginRouter;
